/**
 * Die Kunden-Vorschau (LS-Muster „Admin-Perspektive"): Ein Team-Konto sieht
 * den kompletten Kundenbereich EINES Kunden — Hub, Freigaben, Inhalte,
 * Termine, Strategie, Assistent — mit dessen echten Daten, aber nur lesend.
 *
 * Technisch ist es ein Header an jedem API-Request (`x-kunden-vorschau`),
 * den der Auth-Guard des Backends für Mitarbeiter in eine Kunden-Rolle
 * übersetzt und bei allem außer GET mit 403 abweist. Der Zustand lebt in
 * `sessionStorage` (überlebt Reload, nicht den Tab) — bewusst kein Cookie,
 * damit Eugens normale Sitzung unberührt bleibt.
 */

export const VORSCHAU_HEADER = "x-kunden-vorschau";
const SCHLUESSEL = "olgen.kundenVorschau";

export type KundenVorschau = { customerId: string; name: string };

export function aktiveVorschau(): KundenVorschau | null {
	try {
		const roh = sessionStorage.getItem(SCHLUESSEL);
		if (roh === null) return null;
		const wert: unknown = JSON.parse(roh);
		if (
			typeof wert === "object" &&
			wert !== null &&
			"customerId" in wert &&
			"name" in wert &&
			typeof wert.customerId === "string" &&
			typeof wert.name === "string"
		) {
			return { customerId: wert.customerId, name: wert.name };
		}
		return null;
	} catch {
		return null;
	}
}

export function vorschauSetzen(vorschau: KundenVorschau | null): void {
	try {
		if (vorschau === null) sessionStorage.removeItem(SCHLUESSEL);
		else sessionStorage.setItem(SCHLUESSEL, JSON.stringify(vorschau));
	} catch {
		// Ohne Speicher (privates Fenster) gibt es schlicht keine Vorschau.
	}
}

/** Die Header für jeden API-Request — leer ohne Vorschau. */
export function vorschauHeader(): Record<string, string> {
	const v = aktiveVorschau();
	return v === null ? {} : { [VORSCHAU_HEADER]: v.customerId };
}
